/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import RegulatoryCharges from "./RegulatoryCharges.container";

export default RegulatoryCharges;
